import { useTranslation } from "react-i18next";
import TranscriptionLowConfidenceSvg from "@/assets/transcription_low_confidence.svg?react";
import { TranscriptionMessageTitle } from "../../../TranscriptionMessageTitle/TranscriptionMessageTitle";
import { TranscriptionSubTitle } from "../../../TranscriptionSubTitle/TranscriptionSubTitle";

export function TranscriptionLowConfidence() {
  const { t } = useTranslation();

  return (
    <>
      <TranscriptionLowConfidenceSvg />
      <TranscriptionMessageTitle>
        {t("no_transcript.low_confidence_title")}
      </TranscriptionMessageTitle>
      <TranscriptionSubTitle>
        {t("no_transcript.low_confidence_description")}
      </TranscriptionSubTitle>
    </>
  );
}
